import { DatePicker } from 'antd'

export const AntDatePicker = DatePicker

export default AntDatePicker
